import { request } from "../browser/request";
import { ds24cart_updateItemCount } from "./ds24cart_helper";
import { ds24cart_jsonp_args } from "./ds24cart_jsonp_args";
import { ds24cart_maybe_show_msg } from "./ds24cart_maybe_show_msg";
import { ds24cart_wait_start, ds24cart_wait_stop } from "./ds24cart_wait";
import { ds24_checkout_url } from "../common/ds24_checkout_url";

export function ds24cart_clear_exec() {
    ds24cart_wait_start();

    const url =  ds24_checkout_url() + '/cart/clear/?' + ds24cart_jsonp_args()

    request({
        url,
        dataType: 'jsonp',
        success: ds24cart_callback_clear
    });

    return false;
}

export function ds24cart_callback_clear( result: any )
{
    ds24cart_updateItemCount( 0 );
    ds24cart_wait_stop();
    ds24cart_maybe_show_msg( result );
}
